import './resource-info-modal.css';
